const AdditionalCategory = () => (
    <div>
        <h3>Wzmacniacze</h3>
    </div>
);

export default AdditionalCategory;
